const Forbidden = () => <div>شما به این صفحه دسترسی ندارید</div>;

export default Forbidden;
